@let infoContent = infoContent$ | async;
@let accordionCollection = items$ | async;

<fin-mmb-split-panel>
  <div slot="left">
    @if (infoContent) {
      <h3 class="font-heading-5">{{ infoContent.teaserTitle }}</h3>
      <div class="flex ms-xsmall-t">
        <div class="font-caption-1 ms-xsmall-r">
          <fcom-icon aria-hidden="true" class="icon-small" [name]="SvgLibraryIcon.INFO_BLOCK" />
        </div>
        <div
          [innerHtml]="infoContent.detailText | finSafe: 'html'"
          class="inherit-typography-for-inner-html regular-type font-body-2 ms-large-b"
        ></div>
      </div>
    }
  </div>
  <div slot="right">
    <fin-accordion-list>
      @for (item of accordionCollection?.items; track item.contentId) {
        <fin-accordion-item [key]="item.contentId.toString()" [label]="item.teaserTitle">
          <cms-rich-text
            extraClasses="ms-xsmall-t"
            [headerStyles]="['is-hidden']"
            [content$]="item | finToObservable"
          />
        </fin-accordion-item>
      }
    </fin-accordion-list>
    <cms-rich-text extraClasses="ms-xsmall-t" [headerStyles]="['is-hidden']" [content$]="termsAndConditions$" />
  </div>
</fin-mmb-split-panel>
